((responsiveSidebarMenu) => {
  responsiveSidebarMenu.openSlideMenu = () => {
    document.getElementById('menu').style.width = '250px';
    document.getElementById('page').style.marginLeft = '250px';
  };

  responsiveSidebarMenu.closeSlideMenu = () => {
    document.getElementById('menu').style.width = '0';
    document.getElementById('page').style.marginLeft = '0';
  };
})((window.responsiveSidebarMenu = window.responsiveSidebarMenu || {}));
